var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 101,
    viewBox: "0 0 102 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3356 0.409668C24.662 0.409668 26.265 11.4763 26.265 11.4763L26.2935 22.9416H50.7934V26.3838H16.5626C16.5626 26.3838 0.134033 24.5318 0.134033 50.2803C0.134033 76.0297 14.4733 75.1165 14.4733 75.1165H23.0309V63.1678C23.0309 63.1678 22.5695 48.9149 37.1412 48.9149H61.4406C61.4406 48.9149 75.0928 49.1341 75.0928 35.7999V13.7526C75.0928 13.7526 77.1663 0.409668 50.3356 0.409668ZM36.8264 8.11987C37.4053 8.11935 37.9787 8.23231 38.5137 8.45229C39.0486 8.67228 39.5347 8.99496 39.9441 9.40187C40.3535 9.80878 40.6781 10.2919 40.8994 10.8237C41.1207 11.3555 41.2344 11.9254 41.2339 12.5008C41.2344 13.0763 41.1207 13.6462 40.8994 14.178C40.6781 14.7097 40.3535 15.1929 39.9441 15.5998C39.5347 16.0067 39.0486 16.3294 38.5137 16.5494C37.9787 16.7694 37.4053 16.8823 36.8264 16.8818C36.2474 16.8823 35.6741 16.7694 35.1391 16.5494C34.6041 16.3294 34.118 16.0067 33.7086 15.5998C33.2993 15.1929 32.9746 14.7097 32.7533 14.178C32.532 13.6462 32.4183 13.0763 32.4189 12.5008C32.4183 11.9254 32.532 11.3555 32.7533 10.8237C32.9746 10.2919 33.2993 9.80878 33.7086 9.40187C34.118 8.99496 34.6041 8.67228 35.1391 8.45229C35.6741 8.23231 36.2474 8.11935 36.8264 8.11987Z",
    fill: "url(#paint0_linear_425_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0646 100.41C76.7381 100.41 75.1351 89.343 75.1351 89.343L75.1066 77.8781H50.6064V74.4359H84.8372C84.8372 74.4359 101.266 76.2878 101.266 50.5385C101.266 24.7895 86.9265 25.7027 86.9265 25.7027H78.3689V37.651C78.3689 37.651 78.8302 51.904 64.2585 51.904H39.9591C39.9591 51.904 26.3069 51.6847 26.3069 65.0193V87.0671C26.3069 87.0671 24.2338 100.41 51.0642 100.41M64.5734 92.7001C63.9944 92.7007 63.421 92.5877 62.8861 92.3677C62.3511 92.1477 61.865 91.8251 61.4556 91.4181C61.0462 91.0112 60.7216 90.5281 60.5003 89.9963C60.279 89.4646 60.1653 88.8946 60.1659 88.3192C60.1653 87.7437 60.2789 87.1737 60.5002 86.6419C60.7215 86.1101 61.0461 85.6269 61.4555 85.2199C61.8649 84.813 62.351 84.4903 62.886 84.2703C63.421 84.0503 63.9944 83.9373 64.5734 83.9378C65.1523 83.9373 65.7257 84.0503 66.2607 84.2702C66.7956 84.4902 67.2817 84.8129 67.6911 85.2198C68.1005 85.6267 68.4251 86.1099 68.6464 86.6416C68.8677 87.1734 68.9814 87.7433 68.9809 88.3188C68.9814 88.8942 68.8677 89.4642 68.6464 89.9959C68.4251 90.5277 68.1005 91.0108 67.6911 91.4177C67.2817 91.8247 66.7956 92.1473 66.2607 92.3673C65.7257 92.5873 65.1523 92.7007 64.5734 92.7001Z",
    fill: "url(#paint1_linear_425_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_6",
    x1: 972.007,
    y1: 899.853,
    x2: 5953.84,
    y2: 5861.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387EB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#366994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_425_6",
    x1: 1460.79,
    y1: 1563.17,
    x2: 6812.19,
    y2: 6652.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC331"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/Python.cfae1357aeb9821b86cb0f8475f98f2f.svg";
export { ForwardRef as ReactComponent };